// extracted by mini-css-extract-plugin
export var cardIcon = "_a2-5";
export var cardIconUnframed = "_a2-9";
export var checkboxCard = "_a2-0";
export var checkboxCardSelected = "_a2-4";
export var disabled = "_a2-2";
export var interactive = "_a2-1";
export var outerBorder = "_a2-3";
export var spacerMedium = "_a2-8";
export var spacerSmall = "_a2-7";
export var spacerXsmall = "_a2-6";